import { useParams, useSearchParams } from 'react-router-dom';
import { createContext } from 'react';

import useGetGroupServiceCategory from '../hooks/useGetGroupServiceCategory';

export const ServiceCategoryContext = createContext(null);

export default function ServiceCategoryProvider({ children }) {
  const { categoryId } = useParams();
  const [searchParams] = useSearchParams();
  const organisationId = searchParams.get('organisationId');

  const {
    data: serviceCategory,
    isFetching: isServiceCategoryLoading,
    error,
  } = useGetGroupServiceCategory({ categoryId, organisationId });

  return (
    <ServiceCategoryContext.Provider value={{ serviceCategory, isServiceCategoryLoading, error }}>
      {children}
    </ServiceCategoryContext.Provider>
  );
}
